/**
 * @generated SignedSource<<0431869b55d3156a35b9560d740f7eb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type SingleTaskInProgressCheck_taskExecutionCheck$data = ReadonlyArray<{
  readonly checkValue: TaskSentiment | null;
  readonly updatedAt: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"taskExecutionListCheckTaskExecutions">;
  readonly " $fragmentType": "SingleTaskInProgressCheck_taskExecutionCheck";
}>;
export type SingleTaskInProgressCheck_taskExecutionCheck$key = ReadonlyArray<{
  readonly " $data"?: SingleTaskInProgressCheck_taskExecutionCheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleTaskInProgressCheck_taskExecutionCheck">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SingleTaskInProgressCheck_taskExecutionCheck",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "taskExecutionListCheckTaskExecutions"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "c921dcc01ea56e61887795a2de851755";

export default node;
